import { keyAndValueOrNull } from 'utilities/objectHelpers';
import { formatText } from 'core/i18n';
import { FIOC_TGSS } from 'constants/featureFlagging';

export const checkFiocTgssFlag = () => (_, getState) => getState().featureFlagging.get('data').get(FIOC_TGSS);

export const buildTgssFile = () => (_, getState) => {
    return {
        filename: getState().initialStep.get('pdfDownloadLinkName'),
        fileType: 'tgss',
        file: getState().initialStep.get('pdfDownloadLink'),
    };
};

export const buildTgssFiocBody =
    ({ withDocumentation }) =>
    (dispatch, getState) => {
        const isTgssCheckSelected = Boolean(getState().userProfile.fiocTgssConsent);
        const shouldSendFiocTgssConsent = Boolean(isTgssCheckSelected);
        const consentTgssText = `${formatText('fioc-tgssConsentIAgree')}${formatText(
            'fioc-tgssConsentDocument'
        )}${formatText('fioc-tgssConsentAcceptConsult')}`;

        return {
            checkTgss: isTgssCheckSelected,
            ...keyAndValueOrNull({
                key: 'consentTgssText',
                value: consentTgssText,
                condition: shouldSendFiocTgssConsent,
            }),
            ...keyAndValueOrNull({
                key: 'documentation',
                value: dispatch(buildTgssFile()),
                condition: withDocumentation && shouldSendFiocTgssConsent,
            }),
        };
    };
